export default {
    name: 'Location',
    dimensions: { width: 16, height: 23 },
    content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="8" cy="8.75" r="3"/>
      <path d="M15 8.75C15 12.616 13 15.75 8 21.75C3 15.75 1 12.616 1 8.75C1 4.88401 4.13401 1.75 8 1.75C11.866 1.75 15 4.88401 15 8.75Z"/>
    </g>
  `
};
